
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Link } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface GithubLinkInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const GithubLinkInput = ({ value, onChange }: GithubLinkInputProps) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-2">
      <Label htmlFor="github">{t('common.githubLink')}</Label>
      <div className="flex gap-2">
        <Input
          id="github"
          type="url"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://github.com/..."
          className="flex-1"
        />
        <Button variant="outline" size="icon">
          <Link className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
